export const register = {
  "titleInvite": "ตอบรับคำเชิญ",
  "subtitleInvite": "สร้างบัญชีของคุณเพื่อเข้าร่วมทีม",
  "titlePublic": "สร้างบัญชีร้านค้าของคุณ",
  "subtitlePublic": "ลงทะเบียนเพื่อเริ่มต้นใช้งาน",
  "validating": "กำลังตรวจสอบคำเชิญ...",
  "invalidTitle": "คำเชิญไม่ถูกต้อง",
  "nameLabel": "ชื่อ-นามสกุล",
  "emailLabel": "อีเมล",
  "emailHint": "อีเมลนี้เชื่อมโยงกับคำเชิญของคุณ",
  "passwordLabel": "รหัสผ่าน (ขั้นต่ำ 6 ตัวอักษร)",
  "confirmPasswordLabel": "ยืนยันรหัสผ่าน",
  "passwordMismatch": "รหัสผ่านไม่ตรงกัน",
  "creatingButton": "กำลังสร้างบัญชี...",
  "completeButton": "ลงทะเบียนให้เสร็จสมบูรณ์",
  "createButton": "สร้างบัญชี",
  "loginLink": "มีบัญชีอยู่แล้ว? ลงชื่อเข้าใช้"
};
